import bus from "@/bus";

export const registerNativeHandler = (action, callback) => {
  bus.global.on(action, callback);
  return () => bus.global.off(action, callback);
};

const onMessageFromNative = (message) => {
  // console.log("Received msg from RN: ", message);
  const { type, payload } = JSON.parse(message);
  bus.global.emit(type, payload);
};

window.onMessageFromNative = onMessageFromNative;
